import React from 'react';
import PropTypes from 'prop-types';

import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

function MonthSelector({ selectedMonth, onChange }) {
  const handleSelectedMonth = React.useCallback((e) => onChange(e.target.value), [onChange]);

  return (
    <FormControl>
      <InputLabel id="month-label-id">Month</InputLabel>
      <Select
        labelId="month-label-id"
        label="Month"
        size="small"
        value={selectedMonth}
        onChange={handleSelectedMonth}
        sx={{ height: '3.125rem', mx: 0, padding: '0.625rem', minWidth: '6.5rem' }}
        data-cy="month-select"
      >
        <MenuItem data-cy="clear-month">Month</MenuItem>
        {[...Array(12)].map((_, i) => (
          <MenuItem
            key={new Date(0, i).toLocaleString('default', { month: 'short' })}
            value={i + 1}
          >
            {new Date(0, i).toLocaleString('default', { month: 'long' })}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

MonthSelector.propTypes = {
  selectedMonth: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

export default React.memo(MonthSelector);
